import ProductCategoryPage from "@/components/ProductCategoryPage";
import { productPages } from "@/data/productPages";
export default function Arredamento() { return <ProductCategoryPage data={productPages.arredamento} />; }
